<template>
    <div>
      <!-- 筛选区域 -->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-date-picker
            v-model="filterDate"
            type="month"
            placeholder="选择月份"
            @change="handleFilterChange"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
  
        <el-col :span="8">
          <el-checkbox
            v-model="isSettled"
            @change="handleFilterChange"
            label="是否结算"
          >只显示已结算</el-checkbox>
        </el-col>
      </el-row>
  
      <!-- 返佣列表表格 -->
      <el-table
        :data="tableData"
        style="width: 100%; margin-top: 20px;"
        stripe
        border
      >
      <el-table-column label="返佣ID" prop="saler_rebate_id"></el-table-column>
        <el-table-column label="业务员ID" prop="user_id"></el-table-column>
        <el-table-column label="业务员" prop="user.nickName"></el-table-column>
        <el-table-column label="业务员手机号" prop="user.mobile"></el-table-column>
 
        <!-- <el-table-column label="订单ID" prop="order_id"></el-table-column> -->
        <el-table-column label="月份" prop="month"></el-table-column>
        <!-- <el-table-column label="门店ID" prop="store_id"></el-table-column> -->
        <el-table-column label="返佣金额" prop="rebate" ></el-table-column>
        <el-table-column label="返佣比例" prop="rebate"></el-table-column>
     
        <el-table-column label="业绩" prop="pay_price"></el-table-column>

      
      </el-table>
    </div>
  </template>
  
  <script>
  import SalerApi from '@/api/saler.js';
  export default {
    data() {
      return {
        // 筛选选项
        filterDate: '',
        isSettled: false,
        rebateList: [], // 返佣列表数据


          /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        search: '',
        grade_id: '',
        reg_date: '',
        agent_id: '',
        role:""
      },
      };
    },
    methods: {
      // 日期筛选或结算状态变化时触发的函数
      handleFilterChange() {
        // 调用API或过滤列表，根据选定的筛选条件
        this.getTableList();
      },
  
  
  
  
  
      // 编辑操作
      handleEdit(row) {
        // 实现编辑功能，可能需要打开一个编辑模态框
        console.log('编辑返佣:', row);
      },
  
      // 删除操作
      handleDelete(row) {
        // 实现删除功能（例如，确认删除）
        console.log('删除返佣:', row);
      },
         /*获取列表*/
    getTableList() {
            let self = this
            self.loading = true
            let Params = self.formInline
            Params.page = self.curPage
            Params.list_rows = self.pageSize
            SalerApi.getRebateList(Params, true)
                .then(data => {
                self.loading = false
                self.tableData = data.data.list.data
                self.totalDataNumber = data.data.list.total
                })
                .catch(error => {
                self.loading = false
                });
        },
    },
  
    mounted() {
      // 组件挂载时，获取返佣列表
      this.getTableList();
    },
    

  };
  </script>
  
  <style scoped>
  /* 根据需要添加自定义样式 */
  </style>
  


// WEBPACK FOOTER //
// src/views/plus/saler/index/rb.vue